import uuid from 'uuid/v4'

const propagate = (menus, propagateRole = undefined) => {
  return menus.map(menu => {
    menu.id = uuid()
    if (!menu.role) {
      menu.role = propagateRole
    }
    if (menu.children) {
      menu.chidren = propagate(menu.children, menu.role)
    }
    return menu
  })
}

export default {
  resolve (instance) {
    return propagate([
      {
        icon: 'fa-book',
        title: instance.$t('other'),
        children: [
          {
            title: instance.$t('policy'),
            to: 'policy'
          }
        ],
        displayOrder: 9001
      }
    ])
  }
}



// WEBPACK FOOTER //
// ./src/common/menus.js